$(document).ready(function () {
    if ($('[data-fancybox="certificate"]').length > 0) {
        $('[data-fancybox="certificate"]').fancybox({
            loop: true,
            buttons: [
                "zoom",
                "slideShow",
                "fullScreen",
                "close"
            ]
        });
    }
});
